import "./ProjectCard.styles.scss";
import logo from "../../../Assets/project-icon.svg";
import exclamationcircle from "../../../Assets/exclamationcircle.svg";
import pending from "../../../Assets/pending.svg";
import { useHistory } from "react-router-dom";
import { projectStatus } from "../../../util/helpers/statusHelper"; 
import { Tooltip } from "@material-ui/core";
import { sliceString } from "../../../util/helpers/funcHelper";
//convert date object to string
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function formatDate(d) {
  let date = new Date(d);
  var dd = date.getDate();
  var mm = monthNames[date.getMonth()];
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return (d = dd + " " + mm + " " + yyyy);
}

const ProjectCard = ({ project, setShowDEA }) => {
  const history = useHistory();
  const handleCardClick = () => {
    if (
      project.status === projectStatus.approved.status || project.status === projectStatus.pending.status
    ) {
      history.push(`/console/${project.id}`);
    } else {
      setShowDEA(true);
    }
  };

  const getInfotext=(project)=>{
    switch (project.status){
      case projectStatus.pending.status:
        return 'Approval Pending';
      case projectStatus.approved.status:
        return ''
      case projectStatus.draft.status:
        return 'Please upload DEA File'
      case projectStatus.rejected.status:
        return `${project.comment} Please re-upload DEA File`;
      default:
        return false

    }

  }

  return (
    <div className="console_card" onClick={handleCardClick}>
      <img src={logo} alt="logo" className="console_card_logo" />
      <div className="console_card_name">{sliceString(0,20,project.name,true)}</div>
      <div className="console_card_date">
        Created date: {formatDate(project.created_at)}
      </div>
      <div className="console_card_line"> </div>
      <div
        className={`console_card_status ${
          project.status === projectStatus.approved.status ? ` success` : ` pending`
        }`}
      >
        {project.status!==projectStatus.approved.status &&
           <Tooltip
           title={getInfotext(project)}
           arrow
         >
          <img src={project.status===projectStatus.draft.status || project.status===projectStatus.rejected.status?exclamationcircle:pending}
          alt="logo"
          style={{ marginRight: "0.5em" }}
          className="console_card_img"
        />
        </Tooltip>
        }
        
        <div className="console_card_status_msg">
          {project.status === projectStatus.approved.status
            ? `Total Apps: ${project.appCount}`
            : project.status === projectStatus.pending.status
            ? "Approval Pending"
            : "Upload DEA File"}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
